
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  Flits(document).on('Flits:Navigation:Loaded', function(event){
    var settings = event.detail.settings;
    var obj = 
      {
        title: Flits.t('Flits.locals.navigation.webkul_wallet','My Wallet'),
        url:'#webkul_wallet',
        target:0,
        badge: null,
        icon: null,
        isShow: 1,
        loader:null,
        body_html: '<div class="flits-webkul-wallet-inner"></div>'
      }
      settings.navs.splice(7, 0, obj);
      setTimeout(function(){
        let cloneCode = Flits('.flits-webkul-wallet-main').html();
        Flits('.flits-webkul-wallet-inner').html(cloneCode);
        Flits('.flits-webkul-wallet-main').remove();
      }, 4000);
  });
}(Flits));

/* Kwikpass added the below event */
  Flits(document).on("Flits:AccountPage:Loaded", function (event) {
    Flits(".logoutcustom").on("click", function () {
      event.preventDefault();
      handleLogout();
    });   });
}(Flits));
